import React, { memo } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import _isEqual from 'lodash/isEqual';

import StatusBadge from 'components/StatusBadge';

import { webhookDetails as TEXT } from 'locales/en/webhook';
import { DATE_WITH_HOUR } from 'utils/dateFormat';
import { STATUS_COMPLETED } from 'pages/Webhooks/helpers';

const Summary = ({ webhook }) => {
  const { id, external_id, completed_at, event, created_at } = webhook;
  const { statusCode: status = 'failed' } = webhook.data.content?.status || {};

  return (
    <div className="card mb-8 p-0 flex">
      <div className="grid grid-flow-row gap-y-5 w-2/12 min-w-max border-r border-javelin-gray-border p-12">
        {[
          TEXT.id,
          TEXT.status,
          TEXT.external_id,
          TEXT.event,
          TEXT.created_at,
        ].map((title) => (
          <p key={title} className="text-xs text-javelin-gray-light">
            {title}
          </p>
        ))}
      </div>
      <div className="grid gap-y-5 pl-12 py-12">
        <p className="text-xs text-javelin-gray-dark">{id}</p>
        <StatusBadge
          status={!!completed_at ? STATUS_COMPLETED : status}
          className="ml-0 self-start"
        />
        <p className="text-xs text-javelin-gray-dark">{external_id}</p>
        <p className="text-xs text-javelin-gray-dark">{event}</p>
        <p className="text-xs text-javelin-gray-dark">
          {format(new Date(created_at), DATE_WITH_HOUR)}
        </p>
      </div>
    </div>
  );
};

Summary.propTypes = {
  webhook: PropTypes.shape({}),
};
Summary.defaultProps = {
  webhook: {},
};

const areEqual = (prevProps, nextProps) => {
  return _isEqual(prevProps.webhook, nextProps.webhook);
};

export default memo(Summary, areEqual);
